import * as axios from 'axios';
axios.default.withCredentials = true;

var options = {};
// The server-side needs a full url to works
if (process.server) {
  options.baseURL = 'http://' + (process.env.HOST || 'localhost') + ':' + (process.env.PORT || 3006);
}

export default axios.create(options);


//////////////////
// WEBPACK FOOTER
// ./plugins/axios.js
// module id = ./plugins/axios.js
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17